import { gql } from '@ai4/data-request';

interface Args {
	graphql: {
		list: string;
		queryWithVars?: () => string;
		listFilters?: () => string;
		listDefault?: string;
		isPaginated?: boolean;
	};
	metaDataPrefix?: string;
	table: {
		columns: {
			dataField: string;
			dataNode?: string;
			noData?: boolean;
		}[];
	};
	queryInsert?: (args: Args) => string;
}

export function pathToSlug(path: string) {
	return path.replace(/\./g, '_');
}

export function getListQuery(args: Args) {
	const { graphql, table, metaDataPrefix, queryInsert } = args;
	const [p1, p2] = graphql.list.split('.');

	const rawFields = `
		uniqueId
		${metaDataPrefix ? `${metaDataPrefix} {` : ''}
			insertDate
			updateDate
		${metaDataPrefix ? `}` : ''}
		${queryInsert ? queryInsert(args) : ''}
		${table.columns
			.map((col: any) => {
				if (col.noData) return '';
				let field = col.dataField;
				if (field.includes('.')) {
					// from obj.subobj to obj { subobj }
					const [obj, subobj] = field.split('.');
					field = `${obj} {
						# uniqueId
						${subobj}
					}`;
				}
				return `${col.dataNode || field}`;
			})
			.join('\n')}
	`;

	const queryName = graphql.queryWithVars
		? graphql.queryWithVars()
		: `${pathToSlug(graphql.list)}${graphql.isPaginated ? '($pageNumber: Int! = 0, $pageSize: Int! = 10)' : ''}`;
	const queryListNodeName = graphql.listFilters
		? graphql.listFilters()
		: graphql.listDefault ||
		  (graphql.isPaginated
				? `listaPaginata(paginazione: { pageNumber: $pageNumber, pageSize: $pageSize })`
				: 'lista');
	const raw = `
			query ${queryName} {
				${p1} {
					${p2} {
						${queryListNodeName} {
							${
								graphql.isPaginated
									? `currentPage
									hasNextPage
									hasPreviousPage
									pageSize
									totalCount
									totalPages
									data { ${rawFields} }`
									: `${rawFields}`
							}
							
						}
					}
				}
			}
		`;
	return gql`
		${raw}
	`;
}
